import React  from 'react'

const ParamContext = React.createContext(); 
export default ParamContext;